(function () {
    'use strict';

    angular
        .module('app')
        .controller('CriticalPathDevPatternEditController', criticalPathDevPatternEditController);

    function criticalPathDevPatternEditController($scope, $window, $rootScope, $filter, $timeout, $state, $stateParams, ReportService, ImageUrl, DefaultThumbnailSize, DefaultEnlargeSize, LinePlanService, PatternService, CriticalPathService, UserPreferenceService, toaster, cfpLoadingBar) {
        var model = this;

        model.CriticalPathDevPatternRead = false;
        model.CriticalPathDevPatternEdit = false;
        model.CanViewFactoryFields = $rootScope.globals.currentUser.isFactoryUser !== true;
        model.CanEditName = false;
        $scope.cpNotes = 'cpNotes.html';

        $scope.patternSeasonalId = $stateParams.patternSeasonalId;
        $scope.criticalPathCommercializationId = $stateParams.criticalPathCommercializationId;
        $scope.canViewFactoryFields = $rootScope.globals.currentUser.isFactoryUser !== true;
        $scope.currentUser = $rootScope.globals.currentUser;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {

            if (userPermissionRow[0] === 11) {
                if (userPermissionRow[1] === 1) {
                    model.CriticalPathDevPatternRead = true;
                }
                if (userPermissionRow[1] === 2) {
                    model.CriticalPathDevPatternEdit = true;
                }
            }
        });

        if (model.CriticalPathDevPatternRead === false && model.CriticalPathDevPatternEdit === false) {
            $state.go('permissionDenied');
        }

        model.isReadOnly = true;

        if (model.CriticalPathDevPatternRead === true && model.CriticalPathDevPatternEdit === false) {
            model.isReadOnly = true;
        }

        if (model.CriticalPathDevPatternEdit === true) {
            model.isReadOnly = false;
        }

        model.patternSeasonalId = $stateParams.patternSeasonalId;
        model.criticalPathDevPatternHeaderDetails = "";
        model.cpDevPatternProcessesData = [];
        model.cpDevPatternProcessesToDelete = [];
        $scope.criticalPathDevProcesses = [];


        //UserPreferenceService.getUserPreferences('HeaderMinimized').then(function (response) {
        //    model.headerMinimized = false;
        //    if (response && response.length > 0) {
        //        var userReportModel = eval('(' + response[0].PreferenceValue + ')');
        //        model.headerMinimized = userReportModel.minimized;
        //        model.userPreferenceId = response[0].UserPreferenceId;
        //    }
        //});

        model.minimizeToggle = function () {
            if (model.headerMinimized) {
                model.headerMinimized = false;
            } else {
                model.headerMinimized = true;
            }

            var userPreferenceModel = {
                UserPreferenceId: model.userPreferenceId,
                PreferenceName: "HeaderMinimized",
                model: angular.toJson({ "minimized": model.headerMinimized }),
                EnsureUnique: true
            };

            UserPreferenceService.updateUserPreferences(userPreferenceModel).then(function (response) {
                if (response !== 1) {
                    model.userPreferenceId = response;
                }
            });
        };

        model.init = function () {
            cfpLoadingBar.start();

            CriticalPathService.getCriticalPathHeaderStatusList().then(function (statusData) {
                model.criticalPathHeaderStatusList = statusData;
            });

            model.getCriticalPathDevPatternDetails();
        }

        model.getCriticalPathDevPatternDetails = function () {

            model.cpDevPatternProcessesData = [];
            model.cpDevPatternProcessesToDelete = [];

            CriticalPathService.getCriticalPathDevPatternDetails(model.patternSeasonalId).then(function (response) {
                if (response === null) {
                    $state.go('permissionDenied');
                    cfpLoadingBar.complete();
                    return;
                }

                model.criticalPathDevPatternDetails = response;

                angular.forEach(model.criticalPathDevPatternDetails.Processes, function (k) {
                    k.TargetDate = $filter('date')(k.TargetDate, "MM/dd/yyyy");
                    k.ActualCompleteDate = $filter('date')(k.ActualCompleteDate, "MM/dd/yyyy");
                });

                $scope.criticalPathDevProcesses = model.criticalPathDevPatternDetails.Processes;

                if (model.criticalPathDevPatternDetails.LinePlanLaunchDateId) {
                    LinePlanService.getLinePlanLaunchDateDetails(model.criticalPathDevPatternDetails.LinePlanLaunchDateId).then(function (linePlanLaunchDateResponse) {
                        model.linePlanLaunchDateDetails = linePlanLaunchDateResponse;
                    });
                }
                else {
                    model.linePlanLaunchDateDetails = "";
                }

                if (!model.patternSeasonalDetails) {
                    model.loadPattern();
                }

                if (!model.prototypeCriticalPaths) {
                    CriticalPathService.getGetDevPrototypesForDevPattern(model.criticalPathDevPatternDetails.CriticalPathDevPatternId).then(function (cpPrototypes) {
                        model.prototypeCriticalPaths = cpPrototypes;
                    });
                }

                cfpLoadingBar.complete();
            });
        };

        model.loadPattern = function () {
            PatternService.getPatternSeasonalDetails(model.criticalPathDevPatternDetails.PatternSeasonalId).then(function (patternSeasonalResponse) {
                model.patternSeasonalDetails = patternSeasonalResponse;
                PatternService.getPatternDetails(model.patternSeasonalDetails.PatternId).then(function (patternDetails) {
                    model.patternDetails = patternDetails;

                    PatternService.getDevelopmentCentersForPattern(patternDetails.PatternId).then(function (data) {
                        model.patternDetails.DevelopmentCenter = '';
                        angular.forEach(data, function (k) {
                            if (model.patternDetails.DevelopmentCenter.length > 0) {
                                model.patternDetails.DevelopmentCenter += ', ' + k.DevelopmentCenterName;
                            } else {
                                model.patternDetails.DevelopmentCenter = k.DevelopmentCenterName;
                            }
                        })
                    });

                    model.patternImage = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=1"
                        + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(model.patternDetails.ChangedOn, 'MMddyyHHmmss');

                    model.patternImageFull = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=1"
                        + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(model.patternDetails.ChangedOn, 'MMddyyHHmmss');
                });

                CriticalPathService.getCpCommercializationsForPattern(model.patternSeasonalDetails.PatternId).then(function (cpCommercializationResponse) {
                    model.cpCommercialization = cpCommercializationResponse;
                });
            });
        }

        model.daysRemaining = function (process) {
            if (process.TargetDate === null) return null;
            if (process.ActualCompleteDate === null) return null;

            var targetDate = moment(process.TargetDate).startOf("day");
            var completeDate = moment(process.ActualCompleteDate).startOf("day");

            process.DaysRemaining = targetDate.diff(completeDate, "days");
            return process.DaysRemaining;
        };

        model.checkCPDevPatternName = function (scope) {
            CriticalPathService.isCPDevPatternNameExists(model.criticalPathDevPatternDetails.CriticalPathDevPatternId,
                model.criticalPathDevPatternDetails.CriticalPathDevPatternName)
                .then(function (response) {
                    if (response === true) {
                        toaster.pop({
                            type: 'note',
                            title: 'Name duplication',
                            body: 'You may continue, but please note this name already exists.',
                            timeout: 5000
                        });
                    }
                });
        };

        //Set Selected Row
        model.setIndexId = function (currentIndex) {
            model.indexId = currentIndex;
        };

        model.Save = function (isFormInvalid) {
            if (!isFormInvalid) {
                $scope.criticalPathDevPatternEditForm.$setPristine();

                model.criticalPathDevPatternData = {
                    CriticalPathDevPatternId: model.criticalPathDevPatternDetails.CriticalPathDevPatternId,
                    CriticalPathDevPatternName: model.criticalPathDevPatternDetails.CriticalPathDevPatternName,
                    Factory1Name: model.criticalPathDevPatternDetails.Factory1Name,
                    Factory2Name: model.criticalPathDevPatternDetails.Factory2Name,
                    Factory3Name: model.criticalPathDevPatternDetails.Factory3Name,
                    Factory4Name: model.criticalPathDevPatternDetails.Factory4Name,
                    CriticalPathHeaderStatusId: model.criticalPathDevPatternDetails.CriticalPathHeaderStatusId,
                    Notes: model.criticalPathDevPatternDetails.Notes,
                    DualSrcdPatt: model.criticalPathDevPatternDetails.DualSrcdPatt,
                    FactoryTransfer: model.criticalPathDevPatternDetails.FactoryTransfer
                };

                model.cpDevPatternProcessesData = [];

                var getActualCompleteDate = "";

                for (var i = 0; i < $scope.criticalPathDevProcesses.length; i++) {
                    getActualCompleteDate = "";

                    if ($scope.criticalPathDevProcesses[i].ActualCompleteDate) {
                        var actualCompleteDate = new Date($scope.criticalPathDevProcesses[i].ActualCompleteDate);

                        getActualCompleteDate = $filter('date')(actualCompleteDate, 'short');
                    }

                    model.cpDevPatternProcessesData.push({
                        CriticalPathDevPatternProcessId: $scope.criticalPathDevProcesses[i].CriticalPathDevPatternProcessId,
                        CriticalPathDevPatternId: model.criticalPathDevPatternDetails.CriticalPathDevPatternId,
                        ProcessName: $filter('uppercase')($scope.criticalPathDevProcesses[i].ProcessName),
                        SortOrder: $scope.criticalPathDevProcesses[i].SortOrder,
                        CanBeDeleted: $scope.criticalPathDevProcesses[i].CanBeDeleted,
                        CanChangeName: $scope.criticalPathDevProcesses[i].CanChangeName,
                        ActualCompleteDate: getActualCompleteDate,
                        CriticalPathProcessApprovedId: 6,
                        IsDeleted: false,
                        Notes: $scope.criticalPathDevProcesses[i].Notes
                    });

                }

                for (var j = 0; j < model.cpDevPatternProcessesToDelete.length; j++) {
                    model.cpDevPatternProcessesData.push({
                        CriticalPathDevPatternProcessId: model.cpDevPatternProcessesToDelete[j].CriticalPathDevPatternProcessId,
                        CriticalPathDevPatternId: model.criticalPathDevPatternDetails.CriticalPathDevPatternId,
                        IsDeleted: true
                    });
                }

                CriticalPathService.updateCriticalPathDevPattern(model.criticalPathDevPatternData, model.cpDevPatternProcessesData)
                    .then(function (response) {
                        if (response === 1) {
                            toaster.pop({
                                type: 'success',
                                title: 'Success!',
                                body: 'Record Saved Successfully.',
                                timeout: 5000
                            });
                            model.cpDevPatternProcessesData = [];
                            model.cpDevPatternProcessesToDelete = [];
                            model.getCriticalPathDevPatternDetails();
                        }
                        else {
                            toaster.pop({
                                type: 'error',
                                title: 'Error!',
                                body: 'There was an error while saving the record. Please contact your system administrator',
                                timeout: 5000
                            });
                        }
                        $scope.criticalPathDevPatternEditForm.$setPristine();
                        $scope.criticalPathDevPatternEditForm.$setUntouched();
                    }, function () {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'There was an error while saving the record. Please contact your system administrator',
                            timeout: 5000
                        });
                        $scope.criticalPathDevPatternEditForm.$setPristine();
                        $scope.criticalPathDevPatternEditForm.$setUntouched();
                    });

            }
            else {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Please review all fields indicated in red',
                    timeout: 5000
                });
            }
        };

        model.Report = function () {
            $scope.criticalPathDevPatternEditForm.$setPristine();

            model.parameterValues = [];

            model.parameterValues.push(model.criticalPathDevPatternDetails.CriticalPathDevPatternId);

            var reportName = 'DevPatternCriticalPath';
            var parameterName = 'CriticalPathDevPatternId';
            var parameterValuesList = JSON.stringify(model.parameterValues);

            ReportService.generateReport(reportName, parameterName, parameterValuesList).then(function (response) {
                var file = new Blob([response], { type: 'application/pdf' });
                saveAs(file, reportName + '.pdf');
            }, function () {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was an error generating the report. Please contact your system administrator.',
                    timeout: 5000
                });

            });
        };

        model.Search = function () {
            $state.go("criticalPathIndex", { searchType: 1 });
        };

        $scope.replaceLineBreaks = function (v) {
            if (v) {
                var newValue = v.replace(/[\r\n]+/g, '\xa0\xa0');
                return newValue;
            }
            return null;
        };

        $scope.tableBlur = function (n, o, arr, event) {
            if (arr[o].SortOrder !== arr[o].SortOriginal) {
                event.preventDefault();
                $scope.tableOrder(n, o, arr, event);
            }
        };

        $scope.tableOrder = function (n, o, arr, event, ri) {
            var compareId;
            //if this isnt a re-index, dont run this code
            if (!ri) {
                //check the o.r., you like it so far?
                var oArr = arr;
                if (oArr === 'sortableTable1') {
                    arr = $scope.criticalPathDevProcesses;
                    compareId = 'CriticalPathDevPatternProcessId';
                }

                //sort the model - only necessary on blur
                var dm = false;
                if (n === true) {
                    dm = arr[o][compareId];
                    arr.sort(function (a, b) {
                        return a.SortOrder - b.SortOrder;
                    });
                } else {
                    //dont do it if there is no old index
                    if (o !== false) {
                        //actually moving the index...
                        var obj = arr[o];
                        arr.splice(o, 1);
                        arr.splice(n, 0, obj);
                    }
                }
            }

            //reindex
            var i = 0;
            angular.forEach(arr,
                function (k) {
                    if (dm) {
                        dm === k[compareId] ? n = i : '';
                    };
                    i++;
                    k.SortOrder = i * 10;
                    k.SortOriginal = i * 10;
                });

            //update model
            $scope.$evalAsync(function () {
                $timeout(function () {
                    model.setIndexId(n);
                    if (typeof $scope.focusElement !== 'undefined') {
                        $scope.focusElement.querySelectorAll('.focusInput')[0].focus();
                    }
                });
            });
        };

        $scope.startSortable = function (table) {
            var sortableTable = document.getElementById(table);
            Sortable.create(sortableTable, {
                handle: '.draggable',
                animation: 150,
                onEnd: function (evt) {
                    $scope.focusElement = undefined;
                    $scope.tableOrder(evt.newIndex, evt.oldIndex, evt.from.id);
                }
            });
        };

        $scope.tableOrderKey = function (event, $index, array) {
            //backspace, tab, up, down, left, right arrows, enter
            var allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46, 116];
            var allowedMetaKeys = [65, 86, 67, 88, 82, 90];
            //Ctrl, Ctrl + A, Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + R, Ctrl + Z
            var eventKey = event.key;

            //no spacebar
            if (eventKey === " ") {
                eventKey = 'x';
                //just defaulting it to a value that isnt allowed
            }

            if (isNaN(eventKey) && eventKey !== 'Tab') {
                //if ctrl isnt being pressed
                var ctrlMeta = event.ctrlKey === true || event.metaKey === true;
                if (ctrlMeta) {
                    //move to first
                    if (event.keyCode === 38) {
                        $scope.tableOrder(0, $index, array, null);
                        $scope.focusElement = event.path[3].children[0];
                    }
                    //move to last
                    if (event.keyCode === 40) {
                        $scope.tableOrder(array.length - 1, $index, array, null);
                        $scope.focusElement = event.path[3].children[array.length - 1];
                    }
                } else {
                    if (allowedKeys.indexOf(event.keyCode) === -1) {
                        event.preventDefault();
                    }
                    if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                        event.preventDefault();
                    }

                    //move up 1
                    if (event.keyCode === 38) {
                        if ($index !== 0) {
                            $scope.tableOrder($index - 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index - 1];
                        }
                    }

                    //move down 1
                    if (event.keyCode === 40) {
                        if ($index !== array.length - 1) {
                            $scope.tableOrder($index + 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index + 1];
                        }
                    }
                }
            }
        };

        //default sort order set to false (desc) so when you first click, its asc
        $scope.tableSortDir = '';
        $scope.tableSort = function (h) {
            if (h !== $scope.tableSortName) {
                //reset order direction if new name is chosen
                $scope.tableSortDir = '';
            }

            $scope.tableSortName = h;

            if ($scope.tableSortDir === '') { //first click
                $scope.tableSortDir = false;
                $scope.tableSortClass = 'fa-caret-up';
            } else if ($scope.tableSortDir === false) { //second click
                $scope.tableSortDir = true;
                $scope.tableSortClass = 'fa-caret-down';
            } else { //third click, reset it all
                $scope.tableSortDir = '';
                $scope.tableSortClass = '';
                $scope.tableSortName = '';
            }
        };

        model.setIndexId = function (currentIndex) {
            model.indexId = currentIndex;
        };

        model.addRow = function (idx, arr, a, t) {
            $scope.criticalPathDevPatternEditForm.$setDirty();

            var item = {
                CriticalPathDevPatternProcessId: 0,
                Name: "",
                TargetDate: "",
                ActualCompleteDate: "",
                CanChangeName: true,
                CanBeDeleted: true,
                Notes: "",
                Notes2: null,
                ProcessType: "DEF",
                CanEditActualCompleteDate: true
            };

            arr.splice(idx + a, 0, item);

            var e = document.getElementById(t);
            $scope.focusElement = e.children[idx + a];

            $scope.tableOrder(idx + a, false, arr, true);
        };

        model.canDevPatternCriticalPathBeCanceled = function () {
            $scope.criticalPathDevPatternEditForm.$setValidity('criticalPathCannotBeCanceled', true);

            if (model.criticalPathDevPatternDetails.CriticalPathHeaderStatusId === 1) {
                CriticalPathService.canDevPatternCriticalPathBeCanceled(model.criticalPathDevPatternDetails.CriticalPathDevPatternId)
                    .then(function (response) {

                        if (response === false) {
                            $scope.criticalPathDevPatternEditForm.$setValidity('criticalPathCannotBeCanceled', false);
                        }
                    });
            }
        };

        model.deleteRow = function (currentIndex) {
            $scope.criticalPathDevPatternEditForm.$setDirty();
            if ($window.confirm("This action will delete the current row. Do you want to continue?")) {
                if ($scope.criticalPathDevProcesses[currentIndex].CriticalPathDevPatternProcessId !== 0) {
                    model.cpDevPatternProcessesToDelete.push({ CriticalPathDevPatternProcessId: $scope.criticalPathDevProcesses[currentIndex].CriticalPathDevPatternProcessId });
                }
                $scope.criticalPathDevProcesses.splice(currentIndex, 1);
            }
        };

        //model.init();
    }
})();
